<script setup>
const clientsStore = useClientsStore();

// Use selectedClientId as a key to force page re-render when switching companies
// This ensures all page data is refetched with the new client context
const pageKey = computed(() => clientsStore.selectedClientId || 'default');
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage :key="pageKey" />
    </NuxtLayout>
  </div>
</template>
